import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9311a9e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status",
  style: {"width":"5rem","height":"5rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "upload-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Jetzt Bild hochladen", -1))
const _hoisted_6 = { class: "upload-form" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Lade hier dein Bild für die Slideshow hoch!", -1))
const _hoisted_10 = { style: {"width":"75%","margin":"0 auto"} }
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-card-heading" })
], -1))
const _hoisted_13 = { class: "input-group mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-card-image" })
], -1))
const _hoisted_15 = {
  class: "mb-3",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "secondary-link",
    href: "/"
  }, "Abbrechen und zur Startseite")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_compressor = _resolveComponent("image-compressor")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Title",
                  "aria-label": "Title",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageTitle) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.imageTitle]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_image_compressor, {
                  class: "form-control",
                  done: _ctx.getFiles,
                  scale: 100,
                  quality: _ctx.quality
                }, null, 8, ["done", "quality"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-lg",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
                  style: {"width":"100%"}
                }, " Jetzt Hochladen ")
              ]),
              _hoisted_16
            ])
          ])
        ])
      ]),
      _createVNode(_component_Toast, {
        modelValue: _ctx.showToast,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showToast) = $event)),
        type: _ctx.toastType,
        message: _ctx.toastMessage
      }, null, 8, ["modelValue", "type", "message"])
    ])
  ], 64))
}